import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/instance";
import { qk } from "@/shared/api/queryKeys";
import type { CopilotSummary } from "../types";

/** Fetches copilot meeting summary for RecordSummarySection. */
export function useCopilotSessionSummary(
  copilotSessionId: string,
  options: { enabled: boolean },
) {
  return useQuery({
    queryKey: qk.copilot.summary(copilotSessionId),
    queryFn: async () => {
      const { data } = await api.v1.getCopilotSessionSummary(copilotSessionId);
      return (data as CopilotSummary | null) ?? null;
    },
    enabled: options.enabled,
    retry: 1,
  });
}
